import { render, staticRenderFns } from "./moveToFolder.vue?vue&type=template&id=2adcd4fc"
import script from "./moveToFolder.vue?vue&type=script&lang=js"
export * from "./moveToFolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports